import type { GridOptions } from "ag-grid-enterprise";
import type { GridEmptyStateParams } from "~/components/grid/gridOverlayState";

import GridEmptyState from "~/components/grid/GridEmptyState";

// AG Grid 35 shows agNoMatchingRowsOverlay when a filter empties the grid; it has no component option and reads overlayComponentParams.
const emptyStateOverlayOptions = <TData>(
	base: GridOptions<TData>,
	params: GridEmptyStateParams
): Pick<GridOptions<TData>, "components" | "noRowsOverlayComponentParams" | "overlayComponentParams"> => ({
	components: { ...base.components, agNoMatchingRowsOverlay: GridEmptyState },
	noRowsOverlayComponentParams: params,
	overlayComponentParams: { ...base.overlayComponentParams, ...params }
});

export default emptyStateOverlayOptions;
